import { Table, Thead, Tbody, Tr, TableContainer, Checkbox, Th, Flex } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import NewWindow from "react-new-window";
import NoResults from "../NoResults";
import DocumentRow from "./DocumentRow";
import { Pagination } from "../Pagination/pagination";

const PAGE_SIZE = 30;

const DocumentsTable = ({
  documents,
  columns,
  hideHeader,
  items = [],
  selectedRows,
  onRowSelect,
  onAllRowSelect,
  selectAllChecked,
  isLoading,
}: {
  documents: any[];
  columns: string[];
  hideHeader?: boolean;
  items?: any[];
  selectedRows?: any;
  onRowSelect?: any;
  onAllRowSelect?: any;
  selectAllChecked?: boolean;
  isLoading?: boolean;
}) => {
  const [downloadUrl, setDownloadUrl] = useState("");
  const [deleted, setDeleted] = useState<number[]>([]);
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil((documents || []).length / PAGE_SIZE);
  const startIndex = (currentPage - 1) * PAGE_SIZE;
  const visibleDocuments = (documents || []).slice(startIndex, startIndex + PAGE_SIZE);

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const onDelete = (id: number) => {
    setDeleted([...deleted, id]);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [documents]);

  if (isLoading) return <NoResults message="Loading..." />;

  return documents?.length > 0 ? (
    <Flex direction="column" gap={4}>
      <TableContainer>
        {downloadUrl && <NewWindow url={downloadUrl} onUnload={() => setDownloadUrl("")} />}
        <Table>
          {!hideHeader && (
            <Thead>
              <Tr>
                {columns.includes("select") && (
                  <Th width="36px">
                    <Flex justifyContent="center">
                      <Checkbox
                        colorScheme="teal"
                        isChecked={selectAllChecked}
                        onChange={onAllRowSelect}
                      />
                    </Flex>
                  </Th>
                )}
                {columns.includes("Name") && <Th>Name</Th>}
                {columns.includes("Type") && <Th>Type</Th>}
                {columns.includes("Uploader") && <Th>Uploader</Th>}
                {columns.includes("Uploaded") && <Th>Uploaded</Th>}
                {columns.includes("Loan") && <Th>Loan</Th>}
                {columns.includes("Category") && <Th>Category</Th>}
                {columns.includes("Status") && <Th>Status</Th>}
                {columns.includes("Checklist Item") && <Th>Checklist Item</Th>}
                <Th width="36px"></Th>
              </Tr>
            </Thead>
          )}
          <Tbody>
            {visibleDocuments
              .filter((document: any) => !deleted.includes(document.id))
              .map((document: any) => (
                <DocumentRow
                  key={document.id}
                  document={document}
                  columns={columns}
                  onDelete={onDelete}
                  onDownload={setDownloadUrl}
                  item={items.find(item => item.id === document.loan_item)}
                  onRowSelect={onRowSelect}
                  selectedRows={selectedRows}
                />
              ))}
          </Tbody>
        </Table>
      </TableContainer>

      <Pagination
        totalPages={totalPages}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
        totalCount={documents.length}
        pageSize={PAGE_SIZE}
      />
    </Flex>
  ) : (
    <NoResults message="No documents to display..." />
  );
};

export default DocumentsTable;
